<template>
  <v-btn
    color="#8E8E8E"
    height="50"
    class="text-none rounded-lg"
    style="font-family: Montserrat"
    @click="login"
    :loading="loading"
    block
    outlined
  >
    <div class="d-flex align-center justify-center">
      <div class="d-flex align-center justify-start" style="width: 170px">
        <div>
          <v-img
            :src="logo_google"
            :width="20"
            :height="20"
            contain
            class="login-button-logo me-3"
          />
        </div>
        <div class="login-action-text">{{ $t("login.loginGoogle") }}</div>
      </div>
    </div>
  </v-btn>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "LoginWithGoogle",

  data() {
    return {
      logo_google: require("@/assets/images/logo_google.png"),
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["appBaseUrl"]),
  },

  methods: {
    ...mapMutations(["setAuthError"]),

    login() {
      this.loading = true;

      const url = `${process.env.VUE_APP_API_BASE_URL}/auth`;
      const payload = {
        callback_url: `${this.appBaseUrl}/auth/callback`,
      };

      this.$axios
        .post(url, payload)
        .then((response) => {
          window.location.href = response.data;
        })
        .catch((error) => {
          console.error("login(): ", error);
          const { code } = error?.response?.data || {};
          if (code) {
            this.setAuthError(code);
          } else {
            this.setAuthError("UNKNOWN_ERROR");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.login-text-spotlight {
  color: var(--v-accent-base);
  background-color: rgba(78, 58, 100, 0.9);
  padding: 0px;
  opacity: 0.8;
}

.login-slogan-text {
  font-size: 38px;
}

.login-button-logo {
  mix-blend-mode: multiply;
}
</style>
